<template>
  <v-card width="auto" tile>
    <v-form ref="form">
      <v-card-text>
        <v-row dense>

          <v-col cols="6">
            <v-text-field
              v-model="model.cve_empleado"
              label="clave"
              :rules="fieldRequired"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
          <v-col  cols="12">
              <v-select
                  v-model="model.departamento_id"
                  :items="get_departments"
                  :rules="fieldRequired"
                  item-text="nombre"
                  item-value="id"
                  label="Departamentos"
                  outlined
                  dense>
              </v-select>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="model.nombres"
              label="Nombres"
              :rules="fieldRequired"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="model.apellidos"
              label="Apellidos"
              :rules="fieldRequired"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-layout justify-end>
          <v-btn class="red darken-1 mr-3" dark @click="onCancel">Cancelar</v-btn>
          <v-btn class="green darken-1 mr-3" dark @click="save"> Guardar</v-btn>
        </v-layout>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
export default {
  name: 'EmployeeFormCreate',
  mixins: [Validate],
  props: ['model', 'onSuccess', 'onCancel'],
  data: () => ({
  }),
  mounted () {
    this.getDepartments()
  },
  methods: {
    ...mapActions(['getDepartments']),
    save () {
      if (this.$refs.form.validate()) {
        this.onSuccess(this.model)
      } else {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'ERROR',
          text: 'Hay campos obligatorios'
        })
      }
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_departments'])
  }
}
</script>

<style></style>
